import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const APP_STORE_URL = 'https://apps.apple.com/fr/app/bible4me/id6743235720';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bible4md.app';
const WEB_URL = 'https://bible4.me/app';
const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61587420907306';
const INSTAGRAM_URL = 'https://www.instagram.com/raymondbalmes/';
const TIKTOK_URL = 'https://www.tiktok.com/@raymondbalms';
export const YOUTUBE_URL = 'https://www.youtube.com/@TheBiible';

type SvgProps = React.SVGProps<SVGSVGElement>;

// Logos de marque (SVG inline, fill=currentColor → héritent de la couleur du texte)
const AppleLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701z" />
  </svg>
);

const GooglePlayLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" />
  </svg>
);

const FacebookLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const TiktokLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.43 3.98-2.11 6.15-1.7.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export const YoutubeLogo = (p: SvgProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

interface StoreBadgeProps {
  href: string;
  logo: React.ReactNode;
  line: string;
  name: string;
}

const StoreBadge: React.FC<StoreBadgeProps> = ({ href, logo, line, name }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="inline-flex h-[54px] items-center gap-2 rounded-xl bg-black px-4 text-white no-underline transition-colors hover:bg-neutral-800"
  >
    {logo}
    <span className="flex flex-col items-start leading-none">
      <span className="text-[0.6rem] font-medium">{line}</span>
      <span className="text-[1.05rem] font-semibold tracking-tight">{name}</span>
    </span>
  </a>
);

interface SocialButtonProps {
  href: string;
  label: string;
  children: React.ReactNode;
}

const SocialButton: React.FC<SocialButtonProps> = ({ href, label, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    aria-label={label}
    title={label}
    className="flex h-11 w-11 items-center justify-center rounded-full bg-amber-900 text-white transition-colors hover:bg-amber-800"
  >
    {children}
  </a>
);

type Platform = 'ios' | 'android' | 'other';

/** iPadOS se presente comme un Mac : on le reconnait a l'ecran tactile. */
const detectPlatform = (): Platform => {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'other';
};

/**
 * Appel au telechargement du hero, selon l'appareil : sur telephone, le seul
 * store qui sert, et un lien discret vers les autres plateformes ; sur
 * ordinateur, les deux stores et la version web.
 */
export const HeroDownloadCta: React.FC<{ otherPlatformsHref: string }> = ({ otherPlatformsHref }) => {
  const { t } = useTranslation();
  const [platform, setPlatform] = useState<Platform>('other');
  useEffect(() => setPlatform(detectPlatform()), []);

  const appStore = (
    <StoreBadge
      href={APP_STORE_URL}
      logo={<AppleLogo className="h-7 w-7" />}
      line={t('home.cta.appStoreLine', "Télécharger dans l'")}
      name="App Store"
    />
  );
  const googlePlay = (
    <StoreBadge
      href={PLAY_STORE_URL}
      logo={<GooglePlayLogo className="h-6 w-6" />}
      line={t('home.cta.googlePlayLine', 'Disponible sur')}
      name="Google Play"
    />
  );

  if (platform !== 'other') {
    return (
      <div className="mt-6 flex flex-col items-center gap-2" data-testid="hero-download-cta">
        {platform === 'ios' ? appStore : googlePlay}
        <a
          href={otherPlatformsHref}
          className="text-sm text-amber-800 underline hover:text-amber-900"
        >
          {t('home.hero.otherPlatforms', 'Autres plateformes')}
        </a>
      </div>
    );
  }

  return (
    <div
      className="mt-6 flex flex-wrap items-center justify-center gap-3"
      data-testid="hero-download-cta"
    >
      {appStore}
      {googlePlay}
      <a
        href={WEB_URL}
        target="_blank"
        rel="noreferrer"
        className="inline-flex h-[54px] items-center gap-2 rounded-xl border-2 border-amber-900 px-5 font-semibold text-amber-900 no-underline transition-colors hover:bg-amber-100"
      >
        <Globe size={20} />
        {t('home.cta.webVersion', 'Version Web')}
      </a>
    </div>
  );
};

/** Bloc de la section CTA : téléchargement (stores + web) + réseaux sociaux. */
const CommunityLinks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-8">
      {/* Téléchargement : App Store · Google Play · Version Web */}
      <div className="flex flex-col flex-wrap items-center justify-center gap-3 sm:flex-row">
        <StoreBadge
          href={APP_STORE_URL}
          logo={<AppleLogo className="h-7 w-7" />}
          line={t('home.cta.appStoreLine', "Télécharger dans l'")}
          name="App Store"
        />
        <StoreBadge
          href={PLAY_STORE_URL}
          logo={<GooglePlayLogo className="h-6 w-6" />}
          line={t('home.cta.googlePlayLine', 'Disponible sur')}
          name="Google Play"
        />
        <a
          href={WEB_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-[54px] items-center gap-2 rounded-xl border-2 border-amber-900 px-5 font-semibold text-amber-900 no-underline transition-colors hover:bg-amber-100"
        >
          <Globe size={20} />
          {t('home.cta.webVersion', 'Version Web')}
        </a>
      </div>

      {/* Réseaux sociaux */}
      <div className="flex flex-col items-center gap-2">
        <span className="text-sm font-medium text-amber-800">
          {t('home.cta.followUs', 'Suivez-nous')}
        </span>
        <div className="flex items-center gap-3">
          <SocialButton href={FACEBOOK_URL} label="Facebook">
            <FacebookLogo className="h-5 w-5" />
          </SocialButton>
          <SocialButton href={INSTAGRAM_URL} label="Instagram">
            <InstagramLogo className="h-5 w-5" />
          </SocialButton>
          <SocialButton href={TIKTOK_URL} label="TikTok">
            <TiktokLogo className="h-5 w-5" />
          </SocialButton>
          <SocialButton href={YOUTUBE_URL} label="YouTube">
            <YoutubeLogo className="h-5 w-5" />
          </SocialButton>
        </div>
      </div>
    </div>
  );
};

export default CommunityLinks;
